/* unplugin-vue-components disabled */import { render } from "./persona-info.vue?vue&type=template&id=894f5c24&scoped=true"
import script from "./persona-info.vue?vue&type=script&lang=js"
export * from "./persona-info.vue?vue&type=script&lang=js"

import "./persona-info.vue?vue&type=style&index=0&id=894f5c24&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894f5c24"],['__file',"src/components/cards/persona/persona-info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "894f5c24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('894f5c24', __exports__)) {
    api.reload('894f5c24', __exports__)
  }
  
  module.hot.accept("./persona-info.vue?vue&type=template&id=894f5c24&scoped=true", () => {
    api.rerender('894f5c24', render)
  })

}


export default __exports__